<template>

  <div>



    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-light">

          <div class="searchTitle">
            <b> 출고 조회 </b>
          </div>

          <!-- 조회 조건 영역 -->
          <div class="searchBody">
            <!-- 조회 조건 영역 -->
            <!--        <div class="searchBody">-->
            <!--          <div class="searchBody_brand">-->
            <!--            출고 출고-->
            <!--          </div>-->
            <!--          <div>-->
            <!--            <el-select v-model="statusOption" placeholder="Select">-->
            <!--              <el-option-->
            <!--                  v-for="item in statusOptions"-->
            <!--                  :key="item.value"-->
            <!--                  :label="item.label"-->
            <!--                  :value="item.value">-->
            <!--              </el-option>-->
            <!--            </el-select>-->
            <!--          </div>-->
            <!--        </div>-->
            <div class="searchBody_production">
              일자
            </div>
            <div>
              <el-date-picker
                  v-model="confirmStartDateOption"
                  type="date"
                  placeholder="Pick a day"
                  value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              ~
              <el-date-picker
                  v-model="confirmEndDateOption"
                  type="date"
                  placeholder="Pick a day"
                  value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>

            <!--        <div style="margin-left: 20px">-->
            <!--          파일기본 경로-->
            <!--        </div>-->

            <!--        <div class="searchBody_production">-->
            <!--          <el-input-->
            <!--              id="epcInput"-->
            <!--              size="small"-->
            <!--              placeholder=""-->
            <!--              v-model="filePath">-->
            <!--          </el-input>-->



            <!--        </div>-->
            <!--        <div style="margin-left: 160px">-->

            <!--          <el-button-->
            <!--              :loading="loading"-->
            <!--              type="primary"-->
            <!--              @click="pathUpload"-->
            <!--          >변경</el-button>-->
            <!--        </div>-->


          </div>
          <!-- 조회 조건 영역 -->
          <div class="searchBody">

            <div class="searchBody_brand">
              <el-button
                  :loading="loading"
                  type="primary"
                  @click="search"
              >Search</el-button>
            </div>


            <div style="margin-left: 40px">
              <el-button
                  :loading="loading"
                  type="primary"
                  @click="excelDownFunc"
              >  출고 샘플 다운로드 </el-button>
            </div>


          </div>
        </div> <!-- div class="grid-content bg-purple-light"> -->
      </el-col>

    </el-row>



    <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"

        border
        @selection-change="handleSelectionChange"
        :row-class-name="tableRowClassName"
        size="small"
        :row-style="{height:0+'px'}"
        :cell-style="{padding:0+'px'}"
        :header-cell-style="{background:'#f0f9eb',color:'#606266', height:'10px', padding:'0px'}"
    >
      <el-table-column
          type="selection"
          width="35"
      >
      </el-table-column>

      <el-table-column
          property="company_name"
          label="회사명"
          width="200">
      </el-table-column>


      <el-table-column
          property="out_date"
          label="출고 날짜"
          width="100">
      </el-table-column>



      <el-table-column
          property="count"
          label="출고 개수"
          width="100">
      </el-table-column>



      <!--   <el-table-column-->
      <!--       property="file_name"-->
      <!--       label="파일명"-->
      <!--       width="250">-->
      <!--   </el-table-column>-->

      <!--   <el-table-column-->
      <!--       property="total_count"-->
      <!--       label="COUNT"-->
      <!--       width="100">-->
      <!--   </el-table-column>-->

    </el-table>




    <el-row>
      <el-col :span="24"><div class="pagination"  >

        <el-pagination
            small

            layout="prev, pager, next"
            :total="totalSize"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
        >
        </el-pagination>

        <el-button
            :loading="loading"
            type="primary"
            @click="remove"
        >삭제</el-button>


        <el-button
            :loading="loading"
            type="primary"
            @click="dialogVisible = true"
        > 제품출고 업로드(.csv) </el-button>


        <el-tag type="warning" effect="dark"  style="margin-left: 10px; height: 30px"> COUNT : {{this.totalData.length}}</el-tag>


        <el-dialog
            title="제품출고 파일 업로드"
            :visible.sync="dialogVisible"
            width="30%"
            v-loading="loading"
            :before-close="Confirm"
        >
    <span class="text-reader">
      <form ref="form">

      <input type="file" @change="filesChange" class="FileUpload__default" accept=".csv" multiple  />
      </form>
    </span>

          <span slot="footer" class="dialog-footer">
    <!-- <el-button @click="dialogVisible = false">Cancel</el-button> -->
    <el-button type="primary" @click="Confirm">Confirm</el-button>
  </span>


        </el-dialog>


      </div>
      </el-col>
    </el-row>






  </div>




</template>



<script>
import Axios from 'axios';
import XLSX from 'xlsx';
// import printJS from 'print-js';
// import VueHtmlToPaper from 'vue-html-to-paper';

export default {
  created() {
    this.$store.commit("dayBefore",0);
    this.confirmEndDateOption = this.$store.state.dateOption; // 조회조건에서 현재 날짜 
    this.$store.commit("dayBefore",7);
    this.confirmStartDateOption = this.$store.state.dateOption; // 조회조건이서 현재보다 -7 일
    if (this.$store.state.userId != 'admin') {
      // this.deptSeqOption = this.$store.state.deptSeq;
      // this.deptNameOption = this.$store.state.deptName;
    }

    // console.log()
    // 페이지로딩시 조회
    this.search();
    // this.search2();
    // this.getFilePath();
  },//created    
  data() {
    return {
      // table 관련 data 
      tableData: [],
      totalData: [],
      totalData2:[],
      multipleSelection: [],
      saveData:[],
      saveData2:[],
      currentPage: 1,
      pageSize:10,
      totalSize:0,

      // loading 변수 true 이면 loging 화면 보여줌
      loading:false,



      statusOptions: [{

        value: 'I',
        label: '출고'
      },
        {
          value: 'O',
          label: '출고'
        }, ],
      brandOption: '',
      styleOption :'',
      deptNameOption:'',
      deptSeqOption:0,
      confirmStartDateOption:'',
      confirmEndDateOption:'',
      statusOption:'출고',
      status:'',
      fileList: [],
      text :[],
      dialogVisible: false,
      statusLavel:'',
      filePath:'',
  } // return
  },// data

  methods: {


      async fnPrint(outDate, totalCount, company_name) {
      // document.body.innerHTML = this.$refs.printArea.innerHTML;
      // window.print();


      var win = null;
      win = window.open();
      self.focus();
      win.document.open();

      var temp = " <!doctype html public '-//w3c//dtd xhtml 1.0 transitional//en' 'http://www.w3.org/tr/xhtml1/dtd/xhtml1-transitional.dtd'>\n" +
          "<html xmlns:v='urn:schemas-microsoft-com:vml'\n" +
          "xmlns:o='urn:schemas-microsoft-com:office:office'\n" +
          "xmlns:x='urn:schemas-microsoft-com:office:excel'\n" +
          "xmlns='http://www.w3.org/TR/REC-html40'>";


      temp = temp + "\n" +
          "\n" +
          "<head>\n" +
          "<meta http-equiv=Content-Type content='text/html; charset=utf-8'>\n" +
          "<meta name=ProgId content=Excel.Sheet>\n" +
          "<meta name=Generator content='Aspose.Cell '>\n" +
          "<link rel=File-List href='-f34fA1Ut3SASGuRC_files/filelist.xml'>\n" +
          "<link rel=Edit-Time-Data href='-f34fA1Ut3SASGuRC_files/editdata.mso'>\n" +
          "<link rel=OLE-Object-Data href='-f34fA1Ut3SASGuRC_files/oledata.mso'>\n" +
          "<!--[if gte mso 9]><xml>\n" +
          " <o:DocumentProperties>\n" +
          "  <o:Author>kaiser</o:Author>\n" +
          "  <o:LastPrinted>2022-02-13T19:12:33Z</o:LastPrinted>\n" +
          "  <o:Created>2022-02-13T18:48:38Z</o:Created>\n" +
          "  <o:LastSaved>2022-02-16T17:55:46Z</o:LastSaved>\n" +
          "</o:DocumentProperties>\n" +
          "</xml><![endif]-->\n" +
          "<style>" ;



      temp = temp + "\n" +
          "<!--table\n" +
          " {mso-displayed-decimal-separator:'\\.';\n" +
          " mso-displayed-thousand-separator:'\\,';}\n" +
          "@page\n" +
          " {\n" +
          " mso-header-data:'';\n" +
          " mso-footer-data:'';\n" +
          " margin:0.590551181102362in 0in 0.196850393700787in 0in;\n" +
          " mso-header-margin:0in;\n" +
          " mso-footer-margin:0in;\n" +
          " mso-page-orientation:Portrait;\n" +
          " mso-horizontal-page-align:center;\n" +
          " }\n" +
          "tr\n" +
          " {mso-height-source:auto;\n" +
          " mso-ruby-visibility:none;}\n" +
          "col\n" +
          " {mso-width-source:auto;\n" +
          " mso-ruby-visibility:none;}\n" +
          "br\n" +
          " {mso-data-placement:same-cell;}\n" +
          "ruby\n" +
          " {ruby-align:left;}\n" +
          ".style0\n" +
          " {\n" +
          " mso-number-format:General;\n" +
          " text-align:general;\n" +
          " vertical-align:middle;\n" +
          " white-space:nowrap;\n" +
          " background:auto;\n" +
          " mso-pattern:auto;\n" +
          " color:#000000;\n" +
          " font-size:11pt;\n" +
          " font-weight:400;\n" +
          " font-style:normal;\n" +
          " font-family:'맑은 고딕','sans-serif';\n" +
          " border:none;\n" +
          " mso-protection:locked visible;\n" +
          " mso-style-name:Normal;\n" +
          " mso-style-id:0;}\n" +
          ".font0\n" +
          " {\n" +
          " color:#000000;\n" +
          " font-size:11pt;\n" +
          " font-weight:400;\n" +
          " font-style:normal;\n" +
          " font-family:'맑은 고딕','sans-serif'; }\n" +
          ".font1\n" +
          " {\n" +
          " color:#000000;\n" +
          " font-size:10pt;\n" +
          " font-weight:400;\n" +
          " font-style:normal;\n" +
          " font-family:'Arial','sans-serif'; }\n" +
          ".font2\n" +
          " {\n" +
          " color:#000000;\n" +
          " font-size:8pt;\n" +
          " font-weight:400;\n" +
          " font-style:normal;\n" +
          " font-family:'맑은 고딕','sans-serif'; }\n" +
          ".font3\n" +
          " {\n" +
          " color:#000000;\n" +
          " font-size:12pt;\n" +
          " font-weight:700;\n" +
          " font-style:normal;\n" +
          " font-family:'맑은 고딕','monospace'; }\n" +
          ".font4\n" +
          " {\n" +
          " color:#000000;\n" +
          " font-size:12pt;\n" +
          " font-weight:400;\n" +
          " font-style:normal;\n" +
          " font-family:'맑은 고딕','monospace'; }\n" +
          ".font5\n" +
          " {\n" +
          " color:#000000;\n" +
          " font-size:26pt;\n" +
          " font-weight:700;\n" +
          " font-style:normal;\n" +
          " font-family:'맑은 고딕','monospace'; }\n" +
          ".font6\n" +
          " {\n" +
          " color:#000000;\n" +
          " font-size:10pt;\n" +
          " font-weight:700;\n" +
          " font-style:normal;\n" +
          " font-family:'맑은 고딕','monospace'; }\n" +
          ".font7\n" +
          " {\n" +
          " color:#000000;\n" +
          " font-size:10pt;\n" +
          " font-weight:400;\n" +
          " font-style:normal;\n" +
          " font-family:'맑은 고딕','monospace'; }\n" +
          ".font8" ;

        temp = temp + "\n" +
            "\n" +
            " {\n" +
            " color:#000000;\n" +
            " font-size:8pt;\n" +
            " font-weight:700;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace'; }\n" +
            ".font9\n" +
            " {\n" +
            " color:#000000;\n" +
            " font-size:8pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace'; }\n" +
            "td\n" +
            " {mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:11pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','sans-serif';\n" +
            " border:none;\n" +
            " mso-protection:locked visible;\n" +
            " mso-ignore:padding;}\n" +
            ".style0\n" +
            " {\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:11pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " mso-style-name:'Normal';\n" +
            " }\n" +
            ".style1\n" +
            " {\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".style2\n" +
            " {\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".style3\n" +
            " {\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".style4\n" +
            " {\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".style5\n" +
            " {\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".style6\n" +
            " {\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".style7\n" +
            " {\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".style8\n" +
            " {\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".style9\n" +
            " {\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".style10\n" +
            " {\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".style11\n" +
            " {\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " }" ;
        temp = temp + "\n" +
            ".style12\n" +
            " {\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".style13\n" +
            " {\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".style14\n" +
            " {\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".x15\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:11pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".style16\n" +
            " {\n" +
            " mso-number-format:'0%';\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " mso-style-name:'Percent';\n" +
            " }\n" +
            ".style17\n" +
            " {\n" +
            " mso-number-format:'_\\(\\0022$\\0022* \\#\\,\\#\\#0\\.00_\\)\\;_\\(\\0022$\\0022* \\(\\#\\,\\#\\#0\\.00\\)\\;_\\(\\0022$\\0022* \\0022-\\0022??_\\)\\;_\\(\\@_\\)';\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " mso-style-name:'Currency';\n" +
            " }\n" +
            ".style18\n" +
            " {\n" +
            " mso-number-format:'_\\(\\0022$\\0022* \\#\\,\\#\\#0_\\)\\;_\\(\\0022$\\0022* \\(\\#\\,\\#\\#0\\)\\;_\\(\\0022$\\0022* \\0022-\\0022_\\)\\;_\\(\\@_\\)';\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " mso-style-name:'Currency [0]';\n" +
            " }\n" +
            ".style19\n" +
            " {\n" +
            " mso-number-format:'_\\(* \\#\\,\\#\\#0\\.00_\\)\\;_\\(* \\(\\#\\,\\#\\#0\\.00\\)\\;_\\(* \\0022-\\0022??_\\)\\;_\\(\\@_\\)';\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " mso-style-name:'Comma';\n" +
            " }\n" +
            ".style20\n" +
            " {\n" +
            " mso-number-format:'_\\(* \\#\\,\\#\\#0_\\)\\;_\\(* \\(\\#\\,\\#\\#0\\)\\;_\\(* \\0022-\\0022_\\)\\;_\\(\\@_\\)';\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'Arial','sans-serif';\n" +
            " mso-protection:locked visible;\n" +
            " mso-style-name:'Comma [0]';\n" +
            " }" ;
        temp = temp + "\n" +
            ".x21\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:12pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace';\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".x22\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:center;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:#D9D9D9;\n" +
            " mso-pattern:auto none;\n" +
            " color:#000000;\n" +
            " font-size:12pt;\n" +
            " font-weight:700;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace';\n" +
            " border-top:2px solid windowtext;\n" +
            " border-right:1px solid windowtext;\n" +
            " border-bottom:1px solid windowtext;\n" +
            " border-left:2px solid windowtext;\n" +
            " mso-diagonal-down:none;\n" +
            " mso-diagonal-up:none;\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".x23\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:center;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:#D9D9D9;\n" +
            " mso-pattern:auto none;\n" +
            " color:#000000;\n" +
            " font-size:12pt;\n" +
            " font-weight:700;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace';\n" +
            " border-top:2px solid windowtext;\n" +
            " border-right:1px solid windowtext;\n" +
            " border-bottom:1px solid windowtext;\n" +
            " border-left:1px solid windowtext;\n" +
            " mso-diagonal-down:none;\n" +
            " mso-diagonal-up:none;\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".x24\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:general;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:12pt;\n" +
            " font-weight:700;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace';\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".x25\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:center;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:26pt;\n" +
            " font-weight:700;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace';\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".x26\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:center;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:#D9D9D9;\n" +
            " mso-pattern:auto none;\n" +
            " color:#000000;\n" +
            " font-size:12pt;\n" +
            " font-weight:700;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace';\n" +
            " border-top:2px solid windowtext;\n" +
            " border-right:none;\n" +
            " border-bottom:1px solid windowtext;\n" +
            " border-left:1px solid windowtext;\n" +
            " mso-diagonal-down:none;\n" +
            " mso-diagonal-up:none;\n" +
            " mso-protection:locked visible;\n" +
            " } " ;
        temp = temp + "\n" +
            ".x27\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:center;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:11pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','sans-serif';\n" +
            " border-top:2px solid windowtext;\n" +
            " border-right:2px solid windowtext;\n" +
            " border-bottom:1px solid windowtext;\n" +
            " border-left:none;\n" +
            " mso-diagonal-down:none;\n" +
            " mso-diagonal-up:none;\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".x28\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:center;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:700;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace';\n" +
            " border-top:none;\n" +
            " border-right:1px solid windowtext;\n" +
            " border-bottom:1px solid windowtext;\n" +
            " border-left:2px solid windowtext;\n" +
            " mso-diagonal-down:none;\n" +
            " mso-diagonal-up:none;\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".x29\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:'M\\/d\\/yyyy';\n" +
            " text-align:center;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:700;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace';\n" +
            " border-top:none;\n" +
            " border-right:1px solid windowtext;\n" +
            " border-bottom:1px solid windowtext;\n" +
            " border-left:1px solid windowtext;\n" +
            " mso-diagonal-down:none;\n" +
            " mso-diagonal-up:none;\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".x30\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:center;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:700;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace';\n" +
            " border-top:none;\n" +
            " border-right:1px solid windowtext;\n" +
            " border-bottom:1px solid windowtext;\n" +
            " border-left:1px solid windowtext;\n" +
            " mso-diagonal-down:none;\n" +
            " mso-diagonal-up:none;\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".x31\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:center;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace';\n" +
            " border-top:1px solid windowtext;\n" +
            " border-right:1px solid windowtext;\n" +
            " border-bottom:1px solid windowtext;\n" +
            " border-left:2px solid windowtext;\n" +
            " mso-diagonal-down:none;\n" +
            " mso-diagonal-up:none;\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".x32\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:center;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace';\n" +
            " border-top:1px solid windowtext;\n" +
            " border-right:1px solid windowtext;\n" +
            " border-bottom:1px solid windowtext;\n" +
            " border-left:1px solid windowtext;\n" +
            " mso-diagonal-down:none;\n" +
            " mso-diagonal-up:none;\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".x33\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:center;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace';\n" +
            " border-top:1px solid windowtext;\n" +
            " border-right:1px solid windowtext;\n" +
            " border-bottom:2px solid windowtext;\n" +
            " border-left:2px solid windowtext;\n" +
            " mso-diagonal-down:none;\n" +
            " mso-diagonal-up:none;\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".x34\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:center;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace';\n" +
            " border-top:1px solid windowtext;\n" +
            " border-right:1px solid windowtext;\n" +
            " border-bottom:2px solid windowtext;\n" +
            " border-left:1px solid windowtext;\n" +
            " mso-diagonal-down:none;\n" +
            " mso-diagonal-up:none;\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".x35\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:center;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace';\n" +
            " border-top:1px solid windowtext;\n" +
            " border-right:1px solid windowtext;\n" +
            " border-bottom:none;\n" +
            " border-left:1px solid windowtext;\n" +
            " mso-diagonal-down:none;\n" +
            " mso-diagonal-up:none;\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".x36\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:center;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:10pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace';\n" +
            " border-top:none;\n" +
            " border-right:1px solid windowtext;\n" +
            " border-bottom:1px solid windowtext;\n" +
            " border-left:1px solid windowtext;\n" +
            " mso-diagonal-down:none;\n" +
            " mso-diagonal-up:none;\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".x37\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:center;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:8pt;\n" +
            " font-weight:700;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace';\n" +
            " border-top:1px solid windowtext;\n" +
            " border-right:none;\n" +
            " border-bottom:1px solid windowtext;\n" +
            " border-left:1px solid windowtext;\n" +
            " mso-diagonal-down:none;\n" +
            " mso-diagonal-up:none;\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            ".x38\n" +
            " {\n" +
            " mso-style-parent:style0;\n" +
            " mso-number-format:General;\n" +
            " text-align:center;\n" +
            " vertical-align:middle;\n" +
            " white-space:nowrap;\n" +
            " background:auto;\n" +
            " mso-pattern:auto;\n" +
            " color:#000000;\n" +
            " font-size:8pt;\n" +
            " font-weight:400;\n" +
            " font-style:normal;\n" +
            " font-family:'맑은 고딕','monospace';\n" +
            " border-top:1px solid windowtext;\n" +
            " border-right:2px solid windowtext;\n" +
            " border-bottom:1px solid windowtext;\n" +
            " border-left:none;\n" +
            " mso-diagonal-down:none;\n" +
            " mso-diagonal-up:none;\n" +
            " mso-protection:locked visible;\n" +
            " }\n" +
            "-->\n" +
            "</style>" ;

        temp = temp + "\n" +
            "<!--[if gte mso 9]><xml>\n" +
            " <x:ExcelWorkbook>\n" +
            "  <x:ExcelWorksheets>\n" +
            "   <x:ExcelWorksheet>\n" +
            "    <x:Name>Sheet1</x:Name>\n" +
            "<x:WorksheetOptions>\n" +
            " <x:StandardWidth>2304</x:StandardWidth>\n" +
            " <x:Print>\n" +
            "  <x:ValidPrinterInfo/>\n" +
            "  <x:PaperSizeIndex>9</x:PaperSizeIndex>\n" +
            "  <x:Scale>99</x:Scale>\n" +
            "  <x:HorizontalResolution>600</x:HorizontalResolution>\n" +
            "  <x:VerticalResolution>600</x:VerticalResolution>\n" +
            " </x:Print>\n" +
            " <x:ShowPageBreakZoom/>\n" +
            " <x:Zoom>85</x:Zoom>\n" +
            " <x:Selected/>\n" +
            " <x:TopRowVisible>1</x:TopRowVisible>\n" +
            "</x:WorksheetOptions>\n" +
            "   </x:ExcelWorksheet>\n" +
            "  </x:ExcelWorksheets>\n" +
            "  <x:WindowHeight>15840</x:WindowHeight>\n" +
            "  <x:WindowWidth>29040</x:WindowWidth>\n" +
            "  <x:WindowTopX>28680</x:WindowTopX>\n" +
            "  <x:WindowTopY>-120</x:WindowTopY>\n" +
            "  <x:RefModeR1C1/>\n" +
            "  <x:TabRatio>600</x:TabRatio>\n" +
            "  <x:ActiveSheet>0</x:ActiveSheet>\n" +
            " </x:ExcelWorkbook>\n" +
            " <x:ExcelName>\n" +
            "  <x:Name>PRINT_AREA</x:Name>\n" +
            "  <x:SheetIndex>1</x:SheetIndex>\n" +
            "  <x:Formula>=Sheet1!$B$2:$J$36</x:Formula>\n" +
            " </x:ExcelName>\n" +
            "</xml><![endif]-->\n" +
            "</head>\n" +
            "<body link=blue vlink=purple >\n" +
            "\n" +
            "<table border=0 cellpadding=0 cellspacing=0 width=769 style='border-collapse: \n" +
            " collapse;table-layout:fixed;width:576pt'>\n" +
            " <col width=16 style='mso-width-source:userset;width:12pt'>\n" +
            " <col width=9 style='mso-width-source:userset;width:6.75pt'>\n" +
            " <col width=35 style='mso-width-source:userset;width:26.25pt'>\n" +
            " <col width=82 style='mso-width-source:userset;width:61.5pt'>\n" +
            " <col width=72 style='width:54pt'>\n" +
            " <col width=132 style='mso-width-source:userset;width:99pt'>\n" +
            " <col width=192 style='mso-width-source:userset;width:144pt'>\n" +
            " <col width=123 style='mso-width-source:userset;width:92.25pt'>\n" +
            " <col width=99 style='mso-width-source:userset;width:74.25pt'>\n" +
            " <col width=9 style='mso-width-source:userset;width:6.75pt'>\n" +
            " <tr height=14 style='mso-height-source:userset;height:10.95pt' id='r0'>\n" +
            "<td height=14 width=16 style='height:10.95pt;width:12pt;'></td>\n" +
            "<td width=9 style='width:6.75pt;'></td>\n" +
            "<td width=35 style='width:26.25pt;'></td>\n" +
            "<td width=82 style='width:61.5pt;'></td>\n" +
            "<td width=72 style='width:54pt;'></td>\n" +
            "<td width=132 style='width:99pt;'></td>\n" +
            "<td width=192 style='width:144pt;'></td>\n" +
            "<td width=123 style='width:92.25pt;'></td>\n" +
            "<td width=99 style='width:74.25pt;'></td>\n" +
            "<td width=9 style='width:6.75pt;'></td>\n" +
            " </tr>" ;
        temp = temp + "\n" +
            " <tr height=52 style='mso-height-source:userset;height:39.6pt' id='r1'>\n" +
            "<td height=52 style='height:39.6pt;'></td>\n" +
            "<td colspan=9 class=x25><a name='PRINT_AREA' ><span style='font-size:26pt;color:#000000;font-weight:700;text-decoration:none;text-line-through:none;font-family:'맑은 고딕';'>근무복/유니폼 출고 명세서</span></a></td>\n" +
            " </tr>\n" +
            " <tr height=24 style='mso-height-source:userset;height:18pt' id='r2'>\n" +
            "  <td height=24 style='height:18pt'></td>\n" +
            "  <td></td>\n" +
            "  <td></td>\n" +
            "  <td></td>\n" +
            "  <td></td>\n" +
            "  <td></td>\n" +
            "  <td></td>\n" +
            "  <td></td>\n" +
            "  <td></td>\n" +
            "  <td></td>\n" +
            " </tr>\n" +
            " <tr height=45 style='mso-height-source:userset;height:34.2pt' id='r3'>\n" +
            "<td height=45 style='height:34.2pt;'></td>\n" +
            "<td></td>\n" +
            "<td colspan=4 class=x21 style='mso-ignore:colspan;'>* 병 원 명<span style='mso-spacerun:yes'>&nbsp; </span>: " + company_name  + "</td>\n" +
            "<td class=x21></td>\n" +
            "<td rowspan=2 height=90 class=x35 style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;height:67.65pt;'>확인</td>\n" +
            "<td class=x32>" + company_name + "</td>\n" +
            "<td class=x21></td>\n" +
            " </tr>\n" +
            " <tr height=45 style='mso-height-source:userset;height:34.2pt' id='r4'>\n" +
            "<td height=45 style='height:34.2pt;'></td>\n" +
            "<td></td>\n" +
            "<td colspan=3 class=x21 style='mso-ignore:colspan;'>* 출고일자 : "+ outDate + "</td>\n" +
            "<td class=x21></td>\n" +
            "<td class=x21></td>\n" +
            "<td class=x32>크린토피아</td>\n" +
            "<td class=x21></td>\n" +
            " </tr>\n" +
            " <tr height=35 style='mso-height-source:userset;height:26.25pt' id='r5'>\n" +
            "<td height=35 style='height:26.25pt;'></td>\n" +
            "<td></td>" ;
        temp = temp + "\n" +
            "<td colspan=3 class=x24 style='mso-ignore:colspan;'>* 출고건수 : " + totalCount +" 건</td>\n" +
            "<td class=x21></td>\n" +
            "<td class=x21></td>\n" +
            "<td class=x21></td>\n" +
            "<td class=x21></td>\n" +
            "<td class=x21></td>\n" +
            " </tr>\n" +
            " <tr height=32 style='mso-height-source:userset;height:24.45pt' id='r6'>\n" +
            "<td height=32 style='height:24.45pt;'></td>\n" +
            "<td></td>\n" +
            "<td class=x22>번호</td>\n" +
            "<td class=x23>입고일자</td>\n" +
            "<td class=x23>소유자</td>\n" +
            "<td class=x23>부서</td>\n" +
            "<td class=x23>품목명</td>\n" +
            "<td colspan=2 class=x26 style='border-right:2px solid windowtext;border-bottom:1px solid windowtext;'>Tag NO</td>\n" +
            "<td class=x21></td>\n" +
            " </tr>" ;








        this.loading = true;

        // default data
        let url = this.$url + '/rfidInfo/outDetailList';
        var reqJson = new Object();


        reqJson.out_start_date = outDate;
        reqJson.out_end_date = outDate;
        reqJson.status = 'I';
        reqJson.company_name =  company_name;

        //console.log("============================")
        //console.log(reqJson.status);

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {

          var resDataJson = res.data.rfidInfoDTO;
          this.totalData2=[];
          this.filePath = res.data.filePath;

          if (res.data.resultCode){

            for (var resData in resDataJson) {

              if ( resDataJson[resData]['epc'] != null ) {
                this.totalData2.push({
                  seq: resData  * 1 + 1
                  , epc: resDataJson[resData]['epc']
                  , out_date: resDataJson[resData]['out_date']
                  , member_id: resDataJson[resData]['member_id']
                  , item : resDataJson[resData]['item']
                  , company_name : resDataJson[resData]['company_name']
                  , department_name : resDataJson[resData]['department_name']
                  , member_name : resDataJson[resData]['member_name']
                  , in_date: resDataJson[resData]['in_date']
                });



                temp = temp + " <tr height=25 style='mso-height-source:userset;height:19.2pt' id='r7'>\n" +
                    "<td height=25 style='height:19.2pt;'></td>\n" +
                    "<td></td>\n" +
                    "<td class=x28>" +  (resData  * 1 + 1 ) +  "</td>\n" +
                    "<td class=x29 x:num='44603'>" +  resDataJson[resData]['out_date']     + "</td>\n" +
                    "<td class=x30>" +  resDataJson[resData]['member_name']     + "</td>\n" +
                    "<td class=x30>" +  resDataJson[resData]['department_name']     + "</td>\n" +
                    "<td class=x30>" +  resDataJson[resData]['item']     + "</td>\n" +
                    "<td colspan=2 class=x37 style='border-right:2px solid windowtext;border-bottom:1px solid windowtext;'>" +  resDataJson[resData]['epc']     + "</td>\n" +
                    "<td class=x21></td>\n" +
                    " </tr>\n" +
                    "\n ";


              }
            }
            // 전체 데이터 사이즈
            this.loading = false;
            this.status = reqJson.status;
            this.$message.success(this.$store.state.searchSuccess);
          }else{
            this.$message.error(this.$store.state.dataNotFound);
            this.loading = false;
          }
        }) // await Axios.post
            .catch(error => {
              console.log(error.response)
              this.$message.error(this.$store.state.serverErrorMessage);
              this.loading = false;
            }); // await Axios.post


        temp = temp + "</table>\n" +
            "\n" +
            "<script language = 'javascript' type='text/javascript'>\n" +
            " function ChangeRowspanHiddenData()\n" +
            " {\n" +
            "   var node;\n" +
            "   var params=['r3'];\n" +
            "   for (var i = 0;i < params.length; i++)\n" +
            "   {\n" +
            "       node = document.getElementById(params[i]);\n" +
            "       if (node != null)\n" +
            "       {\n" +
            "           node.style.display = '';\n" +
            "       }\n" +
            "   }\n" +
            " }\n" +
            " ChangeRowspanHiddenData();\n <//script>\\n </body>\n  </html>" ;





      win.document.write(temp);
      win.document.close();
      win.print();
      win.close();

      // temp = temp + this.$refs.printArea.innerHTML;
      // printJS('printArea', 'html');
    },



    async search(){
      this.loading = true;

      // default data 
      let url = this.$url + '/rfidInfo/outList';
      var reqJson = new Object();


      reqJson.out_start_date = this.confirmStartDateOption;
      reqJson.out_end_date = this.confirmEndDateOption;
      reqJson.status = 'O';
      reqJson.company_name =  this.$store.state.company_name;

      if (this.$store.state.accessToken != '100')
        reqJson.rfid_get_order_seq = this.$store.state.rfid_get_order_seq;

      //console.log("============================")
      //console.log(reqJson.status);

      await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
        var resDataJson = res.data.rfidInfoDTO;
        this.totalData=[];
        this.filePath = res.data.filePath;

        if (res.data.resultCode){

          for (var resData in resDataJson) {

            if ( resDataJson[resData]['count'] > 0 ) {
              this.totalData.push({
                seq: resData * 1 + 1
                , count: resDataJson[resData]['count']
                , out_date: resDataJson[resData]['out_date']
                , company_name :   resDataJson[resData]['company_name']
              });
            }
          }



          // 전체 데이터 사이즈 
          this.totalSize = this.totalData.length;
          // 보여주는 부분만 slice 
          this.tableData = this.totalData.slice(0, this.pageSize);
          this.currentPage = 1;
          this.loading = false;
          this.status = reqJson.status;
          this.$message.success(this.$store.state.searchSuccess);
        }else{
          this.$message.error(this.$store.state.dataNotFound);
          this.currentPage = 1;
          this.loading = false;
        }
      }) // await Axios.post
          .catch(error => {
            console.log(error.response)
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
          }); // await Axios.post
    },//search

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    }, //toggleSelection

    // check box click event 
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex === 1) {
        //  return 'warning-row';
      } else if (rowIndex === 3) {
        //  return 'success-row';
      }
      console.log(row);
      return '';
    },
    handleSizeChange(val) {
      console.log(`${val} items per page`);
    },

    // pagging event 
    handleCurrentChange(val) {
      this.tableData = this.totalData.slice( (this.pageSize * val - this.pageSize )   , this.pageSize * val);
    },



    save(value){

      let url = "";

      if (this.multipleSelection.length <= 0)
      {
        this.$message.error("데이터를 선택하세요 ");
        return ;
      }

      // if (value == 1) // 발행접수
      // {
      //   if (this.status != '1') //status 가 1이어야만저장 가능
      //   {
      //     this.$message.error("확정상테의 데이터만 발행접수가 가능합니다. ");
      //     return ;
      //   }
      //   url = this.$url + '/rfidOrder/rfidReceipt';
      // }else

      if (value == 2){
        // if (this.status != '1')
        // {
        //   this.$message.error("발행접수 상태의 데이터만 발행 시작 가능합니다 . ");
        //   return ;
        // }
        url = this.$url + '/rfidOrder/rfidPublishStart';
      }
      //else if (value == 3){
      //    if (this.status != '3')
      //   {
      //     this.$message.error("발행시작 상태의 데이터만 완료 가능합니다 . ");
      //     return ;
      //   }
      //   url = this.$url + '/rfidOrder/rfidPublishComplete';
      // }

      for(var resData in this.multipleSelection){
        this.multipleSelection[resData]['reg_user_id'] = this.$store.state.userId
        this.multipleSelection[resData]['upd_user_id'] = this.$store.state.userId

        this.multipleSelection[resData]['rfid_order_amount'] =  this.multipleSelection[resData]['rfid_order_amount'] *=1;
        this.multipleSelection[resData]['publish_amount'] =  this.multipleSelection[resData]['publish_amount'] *=1;
        this.multipleSelection[resData]['publish_start_number'] =  this.multipleSelection[resData]['publish_start_number'] *=1;
        this.multipleSelection[resData]['publish_end_number'] =  this.multipleSelection[resData]['publish_end_number'] *=1;


      }


      this.loading = true;
      Axios.post(url, this.multipleSelection , this.$store.state.config  ).then(res => {

        //console.log(res);
        let saveCount = res.data;
        this.loading = false;
        this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
        this.search();

      }).catch(error => {
        console.log(error.response)
        this.$message.error(this.$store.state.serverErrorMessage);
        this.currentPage = 1;
        this.loading = false;
      }); // await Axios.post
    }, // save


    excelDownFunc(){

      this.sampleData = [];
      // this.sampleData.push({
      //   qr_code : 'https://makesolutions.kr/?Auth=62366318'
      // });
      //
      // this.sampleData.push({
      //   qr_code : 'https://makesolutions.kr/?Auth=83352123'
      // });
      //
      // this.sampleData.push({
      //   qr_code : 'https://makesolutions.kr/?Auth=84361989'
      // });

      this.sampleData.push({
        판매일자 : '20220613'
        ,판매국가 : '대한민국'
        ,판매도시 : '서울'
        ,판매처명 : '대리점'
        ,판매제품 : '화장품'
        ,qr_code : 'https://makesolutions.kr/?A=916734337181'
      });

      this.sampleData.push({
        판매일자 : '20220613'
        ,판매국가 : '대한민국'
        ,판매도시 : '서울'
        ,판매처명 : '대리점'
        ,판매제품 : '화장품'
        ,qr_code : 'https://makesolutions.kr/?A=876784337181'
      });

      this.sampleData.push({
        판매일자 : '20220613'
        ,판매국가 : '대한민국'
        ,판매도시 : '서울'
        ,판매처명 : '대리점'
        ,판매제품 : '화장품'
        ,qr_code : 'https://makesolutions.kr/?A=736734337181'
      });


      this.loading = true;
      var dataWS = XLSX.utils.json_to_sheet(this.sampleData);
      var wb = XLSX.utils.book_new();
      // workbook에 워크시트 추가
      // 시트명은 'nameData'
      XLSX.utils.book_append_sheet(wb, dataWS, '출고데이터 샘플');
      // 엑셀 파일을 내보낸다.
      this.$store.commit("dayBefore",0); // 오늘날짜
      XLSX.writeFile(wb, "출고데이터_샘플"+'.csv');
      this.loading = false;


    }, //excelDownFunc




    async pathUpload(){


      this.loading = true;

      // default data
      let url = this.$url + '/saveInfo/pathUpdate';
      var reqJson = new Object();


      reqJson.file_full_path = this.filePath;

      await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
        let saveCount = res.data;

        if (saveCount){
          this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
          this.loading = false;

        }else{
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }
      }) // await Axios.post
          .catch(error => {
            console.log(error.response)
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
          }); // await Axios.post


    }, //excelDownFunc

    getCheckSum(hex)
    {
      var chk = hex.length
      var value = 0;
      for(var i=0; i <hex.length; i += 2) {
        value +=  parseInt(hex.substring(i, i+2),16) * chk
        chk ++;
      }
      var res = value * 1224 % 100;
      if (res <= 9)
        return '0' + res;
      else
        return res;
    },

    convertToHex(str) {
      var hex = '';
      for(var i=0;i<str.length;i++) {
        hex += str.charCodeAt(i).toString(16);
      }
      return hex;
    },

    convertToString(hex) {

      //console.log("convertToString");
      //console.log(hex);

      var str = '';
      for(var i=0;i<hex.length; i += 2) {
        str += String.fromCharCode(parseInt(hex.substring(i, i+2),16))
      }
      return str;
    },

    filesChange(e) {
      let fileName = e.target.files[0].name
      let lastIndex = fileName.lastIndexOf('.')
      let fileExtension = fileName.substring(lastIndex, fileName.length).toLowerCase()

      if (fileExtension !== '.xls' ||  fileExtension !== '.csv') {
        // this.$alert('텍스트 파일만 업로드 가능합니다.', '알림', { confirmButtonText: '확인' })
        // return
      }

      let fileList = e.target.files
      if (!fileList.length) return

      const reader = new FileReader()
      const file = e.target.files[0];
      reader.onload =  evt => {
        this.text = evt.target.result;
        const textArray = this.text.split('\n');

        const reqJson=[];


        for(var i in textArray){
          if (i==0)
            continue;

          if (textArray[i].length <= 1)
            break;

          //console.log ("-------------------------------------------------" + i );
          //console.log ("-------------------------------------------------" + textArray );

          const dataArray = textArray[i].trim().split(',');
          console.log (textArray[i].trim().split(','));
          console.log (dataArray[0] );
          console.log (dataArray[0].trim() );


          if (this.$store.state.accessToken != '100') {
            reqJson.push({
              out_product_date: dataArray[0].trim()
              , out_product_country: dataArray[1].trim()
              , out_product_city: dataArray[2].trim()
              , out_product_shop: dataArray[3].trim()
              , out_product_name: dataArray[4].trim()
              , qr_code : dataArray[5].trim()
              , rfid_get_order_seq :  this.$store.state.rfid_get_order_seq
            });
          }else {
            reqJson.push({
              out_product_date: dataArray[0].trim()
              , out_product_country: dataArray[1].trim()
              , out_product_city: dataArray[2].trim()
              , out_product_shop: dataArray[3].trim()
              , out_product_name: dataArray[4].trim()
              , qr_code : dataArray[5].trim()
            });

          }
        }

          this.loading = true;

        //console.log(reqJson);
        let url = "";
        url = this.$url + '/rfidInfo/updateWOutDate';

        Axios.post(url, reqJson , this.$store.state.config  ).then(res => {

          //console.log(res);
          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
          this.search();
          // this.$refs.myFiles.files[0].name = null;
        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post

      }
      reader.readAsText(file)

    },//filesChange


    Confirm(){

      this.dialogVisible = false
    },

    submitUpload() {
      this.$refs.upload.submit();
    },




    async remove(){
      if (this.multipleSelection.length <= 0)
      {
        this.$message.error("데이터를 선택하세요 ");
        return ;
      }
      this.loading = true;
      let url = "";
      url = this.$url + '/rfidInfo/removeWOutDate';
      Axios.post(url, this.multipleSelection , this.$store.state.config  ).then(res => {

        //console.log(res );
        let saveCount = res.data;
        this.loading = false;
        this.$message.success(saveCount +'건 삭제 되었습니다.');
        this.search(false);

      }).catch(error => {
        console.log(error.response)
        this.$message.error(this.$store.state.serverErrorMessage);
        this.currentPage = 1;
        this.loading = false;
      }); // await Axios.post
    }, // remove

  }, //methods
}
</script>

<style>


</style>